import { render } from "./DefaultNoticeSectionCmp.vue?vue&type=template&id=8607f3d0"
import script from "./DefaultNoticeSectionCmp.vue?vue&type=script&lang=js"
export * from "./DefaultNoticeSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__